'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _sharedScreenReaderItemInfo = require('@bibliocommons/shared-screen-reader-item-info');

var _sharedScreenReaderItemInfo2 = _interopRequireDefault(_sharedScreenReaderItemInfo);

var _utilsString = require('@bibliocommons/utils-string');

var _reactIntl = require('react-intl');

require('../styles/BibTextSlide.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BibTextSlide = function BibTextSlide(_ref) {
  var item = _ref.item;

  var renderAuthorLinks = function renderAuthorLinks(bib) {
    if (bib.authors && bib.authors.length > 0) {
      var authorLinks = bib.authors.map(_utilsString.truncate)[0];
      return _react2.default.createElement(
        _reactIntl.FormattedMessage,
        { id: 'by_authors', values: { authorLinks: authorLinks } },
        function (message) {
          return _react2.default.createElement(
            'div',
            { className: 'authors' },
            message
          );
        }
      );
    }
    return null;
  };

  return _react2.default.createElement(
    'div',
    { className: 'cp-bib-text-slide' },
    _react2.default.createElement(_sharedScreenReaderItemInfo2.default, item),
    _react2.default.createElement(
      'div',
      { className: 'inner-box', 'aria-hidden': true },
      _react2.default.createElement(
        'div',
        { className: 'title' },
        (0, _utilsString.truncate)(item.title)
      ),
      item.subTitle && _react2.default.createElement(
        'div',
        { className: 'subtitle' },
        (0, _utilsString.truncate)(item.subTitle)
      ),
      renderAuthorLinks(item)
    )
  );
};

BibTextSlide.propTypes = {
  item: _react.PropTypes.shape({
    format: _react.PropTypes.string,
    subTitle: _react.PropTypes.string,
    title: _react.PropTypes.string.isRequired,
    authors: _react.PropTypes.arrayOf(_react.PropTypes.string)
  }).isRequired
};

exports.default = BibTextSlide;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/shared-slider-jacket-cover/lib/components/BibTextSlide.component.js
// module id = 550
// module chunks = 1